import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { FaEye, FaLock } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'
import { RiLoginBoxFill } from 'react-icons/ri'
import authServices from '../../services/AuthServices';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/UserContext';

function LoginForm() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { setCredentials, setUser, isAuth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuth) {
            navigate('/admin/dashboard', { replace: true });
        }
    }, [isAuth, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!email || !password) {
            setError('Please fill in all fields.');
            return;
        }

        setLoading(true);

        try {
            const res = await authServices.login({ email, password });
            setCredentials({
                access: res.data.access,
                refresh: res.data.refresh,
            });
            const userRes = await authServices.getUserDetails();
            setUser(userRes.data);
            navigate('/admin/dashboard', { replace: true });
            setTimeout(() => {
                toast.success('Welcome back!');
            }, 400);
        } catch (err) {
            console.error('Login error:', err);
            let errorMessage = 'Invalid email or password';
            if (err.response?.data) {
                const data = err.response.data;
                if (data.detail) {
                    errorMessage = data.detail;
                } else if (Array.isArray(data.non_field_errors)) {
                    errorMessage = data.non_field_errors[0];
                } else if (typeof data === 'string') {
                    errorMessage = data;
                }
            }

            setError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            {error && (
                <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md text-sm">
                    {error}
                </div>
            )}
            <form className="flex flex-col gap-6" onSubmit={e => handleSubmit(e)}>
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-text-main dark:text-gray-200" htmlFor="email">Email or Username</label>
                    <div className="relative flex items-center">
                        <input
                            className="w-full h-12 rounded-lg border border-border-color dark:border-gray-600 bg-white dark:bg-[#101c22] px-4 pl-11 text-text-main dark:text-white placeholder:text-text-secondary dark:placeholder:text-gray-500 focus:border-primary focus:ring-1 focus:ring-primary focus:outline-none transition-all"
                            id="email"
                            placeholder="admin@nurseconnect.com"
                            type="email"
                            name="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={loading} />
                        <div className="absolute left-3 text-text-secondary dark:text-gray-500 flex items-center pointer-events-none">
                            <span className="material-symbols-outlined text-[20px]"><MdEmail /></span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label className="text-sm font-medium text-text-main dark:text-gray-200" htmlFor="password">Password</label>
                    </div>
                    <div className="relative flex items-center">
                        <input
                            className="w-full h-12 rounded-lg border border-border-color dark:border-gray-600 bg-white dark:bg-[#101c22] px-4 pl-11 pr-11 text-text-main dark:text-white placeholder:text-text-secondary dark:placeholder:text-gray-500 focus:border-primary focus:ring-1 focus:ring-primary focus:outline-none transition-all"
                            id="password"
                            placeholder="••••••••"
                            name="password"
                            required
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={loading} />
                        <div className="absolute left-3 text-text-secondary dark:text-gray-500 flex items-center pointer-events-none">
                            <span className="material-symbols-outlined text-[20px]"><FaLock /></span>
                        </div>
                        <button className="absolute right-3 text-text-secondary dark:text-gray-500 hover:text-text-main dark:hover:text-white flex items-center transition-colors" type="button">
                            <span
                                className="material-symbols-outlined text-[20px]"
                                onClick={() => setShowPassword(!showPassword)}><FaEye /></span>
                        </button>
                    </div>
                </div>
                <div className="pt-2">
                    <button
                        disabled={loading}
                        type='submit' 
                        className="w-full h-12 bg-primary hover:bg-primary-hover text-white font-bold rounded-lg transition-colors shadow-sm flex items-center justify-center gap-2 group">
                        <span>Sign In</span>
                        <span className="material-symbols-outlined text-[20px] group-hover:translate-x-1 transition-transform"><RiLoginBoxFill /></span>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default LoginForm